import Vue from 'vue'
import VueRouter from 'vue-router'

const Home = () => import( /* webpackChunkName: 'pc' */ './views/Home.vue')

Vue.use(VueRouter)

const routes = [
  {
  path: '/',
  name: 'Home',
  component: Home,
  meta: { pc: true }
}]

const router = new VueRouter({
  mode: 'history',
  base: '',
  routes
})

export default router